<template>
    <div class="modal-user-info" @click="onClose">
        <div class="user-info-modal-box" @click.stop="">
            <div class="user-info-header-box">
                <div class="user-info-title-box">
                    {{ $t("common.Customer_Service") }}
                </div>
            </div>
            <div class="customer-service-body">
                <div
                    class="customer-service-live-chat my-btn"
                    @click="clickLivechat()"
                >
                    {{ $t("common.Live_Chat") }}
                </div>
                <div class="customer-service-email">
                    {{ $t("common.Email") }}: support@banggames.in
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import tools from "../../utils/fun";
import eventConfig from "../../baseConfig/eventConfig";
import dataConfig from "../../baseConfig/dataConfig";

export default {
    name: "Modal",
    props: {},
    data() {
        return {};
    },
    mounted() {

    },
    methods: {
        clickLivechat() {
            tools.toggleTawk(this);
        },
        onClose() {
             tools.emit(eventConfig.playEffect,"pop");
            this.$emit("on-close");
        },
        onOK() {
            this.$emit("on-ok");
        }
    },
};
</script>
<style>
@import "../../assets/css/user.css";
.customer-service-body {
    margin-top: 18px;
    height: 659px;
    width: 580px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.customer-service-live-chat {
    width: 340px;
    height: 80px;
    background: #f82e49;
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.35);
    border-radius: 15px;

    font-size: 30px;
    font-family: Arial;
    font-weight: bold;
    color: #ffffff;
    line-height: 80px;
    text-align: center;
}
.customer-service-email {
    margin-top: 53px;
    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    color: #d3d1d5;
    line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/rummy_customer_service.vue